import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetProjectModificationRequestsById = createAsyncThunk(
  "GetProjectModificationRequestsById/GetProjectModificationRequestsById",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectModificationRequests/GetSpecificProjectModificationRequests",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const DeleteProjectModificationRequests = createAsyncThunk(
  "DeleteProjectModificationRequests/DeleteProjectModificationRequests",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectModificationRequests/DeleteProjectModificationRequests",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateProjectModificationRequests = createAsyncThunk(
  "UpdateProjectModificationRequests/UpdateProjectModificationRequests",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectModificationRequests/EditProjectModificationRequests",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataproject");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const AddProjectModificationRequests = createAsyncThunk(
  "AddProjectModificationRequests/AddProjectModificationRequests",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectModificationRequests/AddProjectModificationRequests",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



export const ProcedureForTransferRequest = createAsyncThunk(
  "AddProjectModificationRequests/ProcedureForTransferRequest",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectModificationRequests/ProcedureForTransferRequest",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const ChangeStatusByUser = createAsyncThunk(
  "AddProjectModificationRequests/ChangeStatusByUser",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectModificationRequests/ChangeStatusByUser",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const ApprovalOfExtensionRequest = createAsyncThunk(
  "ApprovalOfExtensionRequest/ApprovalOfExtensionRequest",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/ProjectModificationRequests/ApprovalOfExtensionRequest",
        param
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const ProjectModificationRequests = createSlice({
  name: "ProjectModificationRequests",
  initialState: {
    ProjectModificationRequests: {},
    loadingProjectModificationRequests: false,
    errorProjectModificationRequests: null,

    AddProjectModificationRequests: {},
    loadingAddProjectModificationRequests: false,
    errorAddProjectModificationRequests: null,

    UpdateProjectModificationRequests: {},
    loadingUpdateProjectModificationRequests: false,
    errorUpdateProjectModificationRequests: null,

    DeleteProjectModificationRequests: {},
    loadingDeleteProjectModificationRequests: false,
    errorDeleteProjectModificationRequests: null,

    ProcedureForTransferRequest: {},
    loadingProcedureForTransferRequest: false,
    errorProcedureForTransferRequest: null,

    ChangeStatusByUser: {},
    loadingChangeStatusByUser: false,
    errorChangeStatusByUser: null,

    ApprovalOfExtensionRequest: {},
    loadingApprovalOfExtensionRequest: false,
    errorApprovalOfExtensionRequest: null,
  },
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetProjectModificationRequestsById.pending, (state, action) => {
        state.loadingProjectModificationRequests = true;
        state.ProjectModificationRequests = action.payload;
        state.errorProjectModificationRequests = null;
      })
      .addCase(
        GetProjectModificationRequestsById.fulfilled,
        (state, action) => {
          state.loadingProjectModificationRequests = false;
          state.ProjectModificationRequests = action.payload; // Assuming payload has the desired data
        }
      )
      .addCase(GetProjectModificationRequestsById.rejected, (state, action) => {
        state.loadingProjectModificationRequests = false;
        state.errorProjectModificationRequests = action.payload;
      })

      .addCase(DeleteProjectModificationRequests.pending, (state, action) => {
        state.loadingProjectModificationRequests = true;
        state.DeleteProjectModificationRequests = action.payload;
        state.errorProjectModificationRequests = null;
      })
      .addCase(DeleteProjectModificationRequests.fulfilled, (state, action) => {
        state.loadingProjectModificationRequests = false;
        state.DeleteProjectModificationRequests = action.payload; // Assuming payload has the desired data
      })
      .addCase(DeleteProjectModificationRequests.rejected, (state, action) => {
        state.loadingProjectModificationRequests = false;
        state.errorDeleteProjectModificationRequests = action.payload;
      })

      .addCase(UpdateProjectModificationRequests.pending, (state, action) => {
        state.loadingUpdateProjectModificationRequests = true;
        state.UpdateProjectModificationRequests = action.payload;
        state.errorUpdateProjectModificationRequests = null;
      })
      .addCase(UpdateProjectModificationRequests.fulfilled, (state, action) => {
        state.loadingUpdateProjectModificationRequests = false;
        state.ProjectModificationRequests = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateProjectModificationRequests.rejected, (state, action) => {
        state.loadingUpdateProjectModificationRequests = false;
        state.errorUpdateProjectModificationRequests = action.payload;
      })

      .addCase(AddProjectModificationRequests.pending, (state, action) => {
        state.loadingProjectModificationRequests = true;
        state.AddProjectModificationRequests = action.payload;
        state.errorAddProjectModificationRequests = null;
      })
      .addCase(AddProjectModificationRequests.fulfilled, (state, action) => {
        state.loadingAddProjectModificationRequests = false;
        state.AddProjectModificationRequests = action.payload; // Assuming payload has the desired data
      })
      .addCase(AddProjectModificationRequests.rejected, (state, action) => {
        state.loadingAddProjectModificationRequests = false;
        state.errorAddProjectModificationRequests = action.payload;
      })

      .addCase(ProcedureForTransferRequest.pending, (state, action) => {
        state.loadingProcedureForTransferRequest = true;
        state.ProcedureForTransferRequest = action.payload;
        state.errorProcedureForTransferRequest = null;
      })
      .addCase(ProcedureForTransferRequest.fulfilled, (state, action) => {
        state.loadingProcedureForTransferRequest = false;
        state.ProcedureForTransferRequest = action.payload; // Assuming payload has the desired data
      })
      .addCase(ProcedureForTransferRequest.rejected, (state, action) => {
        state.loadingProcedureForTransferRequest = false;
        state.errorProcedureForTransferRequest = action.payload;
      })
      ////////////////////////////
      .addCase(ChangeStatusByUser.pending, (state, action) => {
        state.loadingChangeStatusByUser = true;
        state.ChangeStatusByUser = action.payload;
        state.errorChangeStatusByUser = null;
      })

      .addCase(ChangeStatusByUser.fulfilled, (state, action) => {
        state.loadingChangeStatusByUser = false;
        state.ChangeStatusByUser = action.payload; // Assuming payload has the desired data
      })
      .addCase(ChangeStatusByUser.rejected, (state, action) => {
        state.loadingChangeStatusByUser = false;
        state.errorChangeStatusByUser = action.payload;
      })

      .addCase(ApprovalOfExtensionRequest.pending, (state, action) => {
        state.loadingChangeStatusByUser = true;
        state.ApprovalOfExtensionRequest = action.payload;
        state.errorApprovalOfExtensionRequest = null;
      })

      .addCase(ApprovalOfExtensionRequest.fulfilled, (state, action) => {
        state.loadingApprovalOfExtensionRequest = false;
        state.ApprovalOfExtensionRequest = action.payload; // Assuming payload has the desired data
      })
      .addCase(ApprovalOfExtensionRequest.rejected, (state, action) => {
        state.loadingApprovalOfExtensionRequest = false;
        state.errorApprovalOfExtensionRequest = action.payload;
      });
  },
});

export default ProjectModificationRequests.reducer;
